import { createFileRoute, redirect } from '@tanstack/react-router'
import { fetchSession } from '@/lib/queries/session'
import { currentUser } from '@/lib/auth/session'
import { orgRoutes } from '@/lib/routes'

/**
 * The entry point: send the signed-in user to an organization.
 *
 * This is the only place that knows how to answer "which organization", which
 * is why the auth gate redirects here rather than guessing a slug — the slug
 * lives in a table, and the gate runs before any query has been made.
 */
export const Route = createFileRoute('/')({
  loader: async ({ context: { queryClient } }) => {
    const user = await currentUser()
    /* The root gate already sent an anonymous caller to /login, so reaching
       here without one means the session died in between. */
    if (!user) throw redirect({ to: '/login' })

    const session = await fetchSession(queryClient, user.id)
    const organization = session.organizations[0]

    /* Sign-up always creates a personal organization, so an account with none
       is a broken one rather than a new one. Say so instead of looping back to
       a login the user has already passed. */
    if (!organization) {
      throw new Error('This account does not belong to any organization.')
    }

    throw redirect({ ...orgRoutes(organization.slug).qrCodes })
  },
})
